import React from "react";
import { observer } from "mobx-react";
import copilotStore from "Stores/copilotStore";
import { DetailRows, KIND_LABELS, labelize } from "./recordFields";

const EntityDetailPanel = observer(() => {
  const active = copilotStore.activeEntityItem;
  if (!active) return null;
  const { kind, item } = active;

  return (
    <div className="copilotTablePanel copilotEntityDetail">
      <div className="copilotTablePanel__header">
        <div className="copilotTablePanel__headMeta">
          <div className="copilotTablePanel__title">{item.title}</div>
          <div className="copilotTablePanel__count">
            {KIND_LABELS[kind] || labelize(kind)}
            {item.subtitle ? ` · ${item.subtitle}` : ""}
          </div>
        </div>
        <span
          className="material-icons-outlined copilotTablePanel__close"
          onClick={copilotStore.closeEntityPanel}
        >
          close
        </span>
      </div>
      <div className="copilotTablePanel__body copilotEntityDetail__body">
        <DetailRows record={item.detail} kind={kind} />
      </div>
    </div>
  );
});

export default EntityDetailPanel;
